import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";
const DevelopView = lazy(() => import("shared/components/develop"));
const ModerHseView = lazy(() => import('../../_deziiign/main/pages/moderHseView/moderHseView'));
const ModerView = lazy(() => import('../../_deziiign/main/pages/moderView/moderView'));
const VacanciesPage = lazy(() => import('shared/pages/vacancies/index'));


const deprecatedRoutes = [
    { path: LinkTo.develop, component: DevelopView },
    { exact: true, path: LinkTo.moder, component: ModerView, isPrivate: true },
    { exact: true, path: "/moder-hse", component: ModerHseView, isPrivate: true },
    { path: '/vacancies', exact: true, component: VacanciesPage },
]

export default deprecatedRoutes;import { lazy } from "react";
import { LinkTo } from "shared/constants/linkTo";
const DevelopView = lazy(() => import("shared/components/develop"));
const ModerHseView = lazy(() => import('../../_deziiign/main/pages/moderHseView/moderHseView'));
const ModerView = lazy(() => import('../../_deziiign/main/pages/moderView/moderView'));
const VacanciesPage = lazy(() => import('shared/pages/vacancies/index'));


const deprecatedRoutes = [
    { path: LinkTo.develop, component: DevelopView },
    { exact: true, path: LinkTo.moder, component: ModerView, isPrivate: true },
    { exact: true, path: "/moder-hse", component: ModerHseView, isPrivate: true },
    { path: '/vacancies', exact: true, component: VacanciesPage },
]

export default deprecatedRoutes;